/* eslint-disable no-mixed-spaces-and-tabs */
import React, { useEffect, useMemo, useState } from 'react';
import ToolbarDropdown from './ToolbarDropdown';
import ReactMarkdown from 'react-markdown';
import ReactDOMServer from 'react-dom/server';
import { formatDate } from '@/utils/constants';
import useGetAIMessages from '@/hooks/useGetAIMessages';
import LinkRenderer from '@/components/LinkRenderer';
import remarkGfm from 'remark-gfm';

const RiskInfoDropdown = ({ dealId, onChange }) => {
	const { getMessages, isLoading, isUninitialized, isError, isSuccess } = useGetAIMessages({
		dealId,
	});

	const messages = useMemo(
		() => getMessages({ summaryType: 'riskInfoEmail' }),
		[isLoading, isUninitialized, isError, isSuccess],
	);

	const fields = useMemo(() => {
		return messages.map((summary, i) => {
			const formattedDate = formatDate(summary.createdWhen, true);
			const label =
				summary.emailType === 'NB'
					? `New Business Terms Request ${formattedDate}`
					: summary.emailType === 'Renewal'
						? `Renewal Client Confirmation ${formattedDate}`
						: `Email generated ${formattedDate}`;
			return {
				label,
				value: `${summary.createdWhen}-${i}`,
				data: summary.message,
				type: 'riskInfo',
				node: 'div',
			};
		});
	}, [messages]);

	const getNodeValue = (event) => {
		const field = fields.find((v) => v.value === event.target.value);

		const component = (
			<ReactMarkdown
				components={{ a: LinkRenderer, link: LinkRenderer }}
				remarkPlugins={[remarkGfm]}
			>
				{field.data}
			</ReactMarkdown>
		);
		const nodeString = ReactDOMServer.renderToStaticMarkup(component);
		const node = `<${field.node}>${nodeString}</${field.node}>`;
		onChange(node);
	};

	const showDropdown = dealId && dealId !== '[TEST_DEAL]' && messages.length > 0;

	return (
		<>
			{showDropdown && (
				<ToolbarDropdown
					title={'generated email'}
					fields={fields}
					onChange={getNodeValue}
				/>
			)}
		</>
	);
};

export default RiskInfoDropdown;
